<template>
  <v-container fluid grid-list-sm>
    <v-flex d-flex xs12 pa-2>
      <TemplateDataHeader :template-id="templateId"/>
    </v-flex>

    <v-flex d-flex xs12 pa-2>
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{ $t('template_title') }}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <TemplatePreparation :template-id="templateId"/>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-container>
</template>

<i18n>
    {
        "de": {
            "template_title": "Fragenkatalog",
            "template_description": "Audit Vorbereitung - TEMPLATE"
        },
        "en": {
            "template_title": "Audit-Template",
            "template_description": "Audit Preparation - TEMPLATE"
        }
    }
</i18n>

<script>
// Widgets
import TemplateDataHeader from "@/components/widgets/TemplateDataHeader.vue";
import TemplatePreparation from "@/components/widgets/TemplatePreparation.vue";
import TemplateIdBaseMixin from "@/components/mixins/TemplateIdBaseMixin";

export default {
  components: {
    TemplateDataHeader,
    TemplatePreparation
  },
  mixins: [TemplateIdBaseMixin]
};
</script>
